import { Injectable } from '@angular/core';
import {GetSecretValueCommand, SecretsManagerClient} from "@aws-sdk/client-secrets-manager";
import {ApiKvPair} from "../models/api-kv-pair";
import {SendEmailCommand, SendEmailResponse, SESClient} from "@aws-sdk/client-ses";
import {ApplicationRequest} from "../models/application-request";
import {ServiceRequest} from "../models/service-request";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs";

const REGION: string = 'us-east-1';
const CRED = {
  accessKeyId: '',
  secretAccessKey: ''
}

const FROM_ADDRESS: string = 'itservice@qor-is.com';
const TO_ADDRESS: string = 'dispatch@qor-is.com';

@Injectable({
  providedIn: 'root'
})
export class AwsService {
  private secretManager = new SecretsManagerClient({
    region: REGION,
    credentials: CRED
  });

  private ses: SESClient = new SESClient({
    region: REGION,
    credentials: CRED
  });

  constructor(private httpClient: HttpClient) { }

  public async sendEmail2(request:ApplicationRequest | ServiceRequest): Promise<any>{
    try {
      let cmd: SendEmailCommand;
      if(request instanceof ApplicationRequest){
        cmd = this.getApplicationEmail(request);
      }else{
        cmd = this.getServiceRequestEmail(request);
      }

      return this.httpClient.post('https://api.qorcompanies.com/mail', {
        to: ['dispatch@qor-is.com','itservice@qor-is.com'],
        subject: cmd.input.Message!.Subject!.Data,
        body: cmd.input.Message!.Body!.Html!.Data,
        replyTo: request.email ?? '[EMAIL NOT PROVIDED]'
      }, {headers:{'x-api-key': '8AuaZ5LK8S66KHtEvxXsm4lIV8rtAsTr8ZFet6mn'}}).pipe(map(value => {
        if((value as any).body){
          return JSON.parse((value as any).body);
        }
        return undefined;
      })).toPromise();
    }
    catch (e) {
      console.error("Failed to send email.", e);
      return Promise.resolve({
        MessageId: JSON.stringify(e)
      } as SendEmailResponse)
    }
  }

  public async sendMail(request: ApplicationRequest | ServiceRequest): Promise<SendEmailResponse>{
    try {
      let cmd: SendEmailCommand;
      if(request instanceof ApplicationRequest){
        cmd = this.getApplicationEmail(request);
      }else{
        cmd = this.getServiceRequestEmail(request);
      }

      return await this.ses.send(cmd);
    } catch (e) {
      console.error("Failed to send email.", e);
      return Promise.resolve({
         MessageId: JSON.stringify(e)
      } as SendEmailResponse)
    }
  }

  private getApplicationEmail(request: ApplicationRequest): SendEmailCommand{
    return new SendEmailCommand({
      Destination: {
        /* required */
        CcAddresses: [
          /* more items */
        ],
        ToAddresses: [
          'dispatch@qor-is.com',
          'itservice@qor-is.com'
          /* more To-email addresses */
        ],
      },
      Message: {
        /* required */
        Body: {
          /* required */
          Html: {
            Charset: "UTF-8",
            Data: `
<style>
label{
  font-family: 'Arial',sans-serif;
}
table{
\tborder: 1px solid black;
\tfont-size: 24pt;
  font-family: 'Arial',sans-serif;
  min-width: 500px;
}
tr.header{
  background-color: #373863;
  color: white;
  text-align: center;
  font-size: 30pt;
}
th{
  padding: 5px;
}
tr.field{}
td{
  border: 1px solid lightgray;
  text-wrap: normal;
  padding: 5px;
}
td.field{
  font-weight: bold;
  width: 350px;
}
td.value{}
</style>

<table>
<thead>
  <tr class="header">
    <th colspan="2">
      Job Application
    </th>
  </tr>
</thead>
<tbody>
  <tr>
    <td class="field">Name: </td>
    <td class="value"> ${request.name ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Email: </td>
    <td class="value"> ${request.email ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Phone Number: </td>
    <td class="value">${request.phoneNumber ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Address: </td>
    <td class="value">${request.address ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Date Of Birth: </td>
    <td class="value"> ${request.dob ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Type Of Experience: </td>
    <td class="value">${request.typeOfExperience ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">CDL: </td>
    <td class="value">${request.cdl ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Additional Information: </td>
    <td class="value">${request.message ?? ''}</td>
  </tr>
</tbody>
</table>
            `,
          },
          Text: {
            Charset: "UTF-8",
            Data: "",
          },
        },
        Subject: {
          Charset: "UTF-8",
          Data: "Job Application Received",
        },
      },
      Source: FROM_ADDRESS,
      ReplyToAddresses: [
        /* more items */
        request.email ?? '[EMAIL NOT PROVIDED]'
      ],
    })
  }

  private getServiceRequestEmail(request: ServiceRequest): SendEmailCommand{
    return new SendEmailCommand({
      Destination: {
        /* required */
        CcAddresses: [
          /* more items */
        ],
        ToAddresses: [
          'dispatch@qor-is.com',
          'itservice@qor-is.com'
          /* more To-email addresses */
        ],
      },
      Message: {
        /* required */
        Body: {
          /* required */
          Html: {
            Charset: "UTF-8",
            Data: `
<style>
label{
  font-family: 'Arial',sans-serif;
}
table{
\tborder: 1px solid black;
\tfont-size: 24pt;
  font-family: 'Arial',sans-serif;
  min-width: 500px;
}
tr.header{
  background-color: #373863;
  color: white;
  text-align: center;
  font-size: 30pt;
}
th{
  padding: 5px;
}
tr.field{}
td{
  border: 1px solid lightgray;
  text-wrap: normal;
  padding: 5px;
}
td.field{
  font-weight: bold;
  width: 350px;
}
td.value{}
</style>

<table>
<thead>
  <tr class="header">
    <th colspan="2">
      Service Request
    </th>
  </tr>
</thead>
<tbody>
  <tr>
    <td class="field">Name: </td>
    <td class="value"> ${request.name ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Email: </td>
    <td class="value"> ${request.email ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Phone Number: </td>
    <td class="value">${request.phoneNumber ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Delivery Location: </td>
    <td class="value">${request.deliveryLocation ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Date Needed: </td>
    <td class="value"> ${request.dateNeeded ?? 'N/A'}</td>
  </tr>
  <tr>
    <td class="field">Service(s) Needed: </td>
    <td class="value">${request.requestedServices.map(x => x.name).join(', ')}</td>
  </tr>
  <tr>
    <td class="field">Additional Information: </td>
    <td class="value">${request.message ?? ''}</td>
  </tr>
</tbody>
</table>
            `,
          },
          Text: {
            Charset: "UTF-8",
            Data: "",
          },
        },
        Subject: {
          Charset: "UTF-8",
          Data: "Service Request Received",
        },
      },
      Source: FROM_ADDRESS,
      ReplyToAddresses: [
        /* more items */
        request.email ?? '[EMAIL NOT PROVIDED]'
      ],
    })
  }
}
